import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Link, Grid } from '@mui/material';
import { colors } from '../theme';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: colors.royalBlue,
        color: 'white',
        py: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {/* About Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t('about')}
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Lions Clubs International District 303 Hong Kong & Macao, China
              <br />
              國際獅子會中國港澳三O三區
            </Typography>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={8}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t('contactUs')}
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Lions Clubs International District 303 Hong Kong & Macao, China
              <br />
              Email: info@lionsclubs.org.hk
            </Typography>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box
          sx={{
            borderTop: `1px solid rgba(255,255,255,0.2)`,
            mt: 4,
            pt: 3,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            {t('copyright', { year: currentYear })}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
            {t('allRightsReserved')}
          </Typography>
          <Box sx={{ mt: 1 }}>
            <Link
              href="#"
              color="inherit"
              underline="hover"
              sx={{ opacity: 0.8, mx: 1, fontSize: '0.875rem' }}
            >
              {t('privacyPolicy')}
            </Link>
            <Link
              href="#"
              color="inherit"
              underline="hover"
              sx={{ opacity: 0.8, mx: 1, fontSize: '0.875rem' }}
            >
              {t('termsOfUse')}
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
